import AbstractProvidedClass from "../shared/AbstractProvidedClass";
import DataTable from "./edit/Fields/DataTable";
import SimpleField from "./edit/Fields/SimpleField";

export default class SpeciesInfo extends AbstractProvidedClass {
    species = null;

    constructor(provider) {
        super(provider);

        this.container = this.p.createDiv().parent('#p5canvas')
            .style('position', 'fixed')
            .style('top', '0')
            .style('height', '100dvh')
            .style('width', '264px')
            .style('padding', '10px')
            .style('background', '#fff')
            .style('border-left', '2px solid #000')
            .style('overflow-y', 'auto')
            .style('box-sizing', 'border-box')
            .style('z-index', '7');
        this.reposition();

        this.fields = this.createFields();

        this.container.hide();
    }

    setSpecies(species) {
        if (this.touch) return;
        this.species = species;
        if (this.species) {
            this.fields.map((field) => field.populate(this.species));
            this.container.show();
        } else {
            this.container.hide();
        }
    }

    reposition() {
        const rightOffset = this.sideBar.menuWidth + this.sideBar.width;
        this.container.style('right', `${rightOffset}px`);
    }

    createFields() {
        return [
            SimpleField.setup(this.provider)
                .setType('h3')
                .style('margin', '0')
                .parent(this.container)
                .setPopulate((species, field) => field.html(species.name))
                .make(),
            SimpleField.setup(this.provider)
                .setType('h4')
                .setPopulate((species, field) => field.html(species.scientific_name))
                .parent(this.container)
                .make(),
            DataTable.setup(this.provider)
                .parent(this.container)
                .make(),
        ];
    }
}
